import React from 'react';
import { Link } from 'react-router-dom';
import { faqGroups } from '../data/siteContent';
import { PageHero } from '../components/PageHero';
import { SectionNav } from '../components/SectionNav';
import { Accordion } from '../components/Accordion';
export function FAQs() {
  return <div className="w-full bg-paper" data-id="element-426" data-mp="1l0iqn86gmhbd">
      <PageHero eyebrow="FAQs" title="Frequently asked." intro="The questions that come up most. If yours is not here, the form takes ten seconds." data-id="element-427" data-mp="1kzg0x3kvikx1" />

      <SectionNav label="FAQ sections" items={faqGroups.map(g => ({
      label: g.title,
      to: `#${g.id}`
    }))} data-id="element-428" data-mp="1b2uucdt7h1r3" />

      <section className="mx-auto max-w-[1400px] px-6 pb-28 pt-16 md:pt-24" data-id="element-429" data-mp="xcrgob8e6gd9">
        <div className="max-w-3xl space-y-20" data-id="element-430" data-mp="11dteqoqkomdn">
          {faqGroups.map(g => <section key={g.id} id={g.id} className="scroll-mt-40" data-id="element-431" data-mp="nch3gqmcx8y3">
              <h2 className="type-display mb-6 text-3xl text-coffee md:text-4xl" data-id="element-432" data-mp="nfd10dualvm0">
                {g.title}
              </h2>
              <Accordion items={g.items} data-id="element-433" data-mp="2otl7zq5wvt9k" />
            </section>)}

          <div className="flex flex-col items-start gap-6 rounded-4xl bg-paper-warm p-10 md:flex-row md:items-center md:justify-between" data-id="element-434" data-mp="2jv085ruknbln">
            <div data-id="element-435" data-mp="2xtq7le4v5nd6">
              <h2 className="type-display text-2xl text-coffee md:text-3xl" data-id="element-436" data-mp="2xu9e7yp2cpbw">
                Still stuck?
              </h2>
              <p className="type-body mt-2 max-w-md text-sm text-ink/60" data-id="element-437" data-mp="2stvf565fwpq0">
                Real people, South African hours, one working day.
              </p>
            </div>
            <Link to="/contact" className="type-cta shrink-0 rounded-full bg-coffee px-8 py-4 text-[11px] text-paper transition-colors hover:bg-pennant" data-id="element-438" data-mp="2163b5g7si4zq">
              Contact us
            </Link>
          </div>
        </div>
      </section>
    </div>;
}